











import Vue from 'vue'
export default Vue.extend({
  props: {
    variation: {
      type: String,
      default: '',
    },
  },
})
